import Footer from "./Footer";
import Header from "./Header";
import IDCard from "./IDCard";
import Terminal from "./Terminal";

export default function App() {
  return (
    <div className="parent">
      <div className="div1">
        <Header />
      </div>
      <div className="div2">
        <Footer />
      </div>
      <div className="div3">
        <IDCard />
      </div>
      <div className="div4">
        <Terminal />
      </div>
    </div>
  )
}